import type { FlatNamespace, KeyPrefix, TFunction } from 'i18next'
import {
  useTranslation as useLibTranslation,
  type FallbackNs,
  type UseTranslationOptions,
  type UseTranslationResponse,
} from 'react-i18next'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type GetFirstArgument<T> = T extends (arg: infer A, ...args: any[]) => any ? A : never
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type GetSecondArgument<T> = T extends (arg1: any, arg2: infer B, ...args: any[]) => any ? B : never
type $Tuple<T> = readonly [T?, ...T[]]

export function useTranslation<
  Ns extends FlatNamespace | $Tuple<FlatNamespace> | undefined = undefined,
  KPrefix extends KeyPrefix<FallbackNs<Ns>> = undefined,
>(ns?: Ns, options?: UseTranslationOptions<KPrefix>): UseTranslationResponse<FallbackNs<Ns>, KPrefix> {
  const useTranslationResponse = useLibTranslation<Ns, KPrefix>(ns, options)

  const tFunc = (a: GetFirstArgument<typeof useTranslationResponse.t>, b: GetSecondArgument<typeof useTranslationResponse.t>) => {
    //Interpolation or other fantastic tasks
    return useTranslationResponse.t(a, b)
  }

  tFunc.$TFunctionBrand = useTranslationResponse.t.$TFunctionBrand
  return {
    ...useTranslationResponse,
    t: tFunc as TFunction<FallbackNs<Ns>, KPrefix>,
  }
}
